import { gql } from "@apollo/client";

// ============================================================
// Conversations
// ============================================================

export const GET_TOM_CONVERSATIONS = gql`
  query TomConversations {
    tomConversations {
      id
      title
      status
      moduleContext
      entityContext
      lastMessageAt
      messageCount
      createdAt
    }
  }
`;

export const GET_TOM_CONVERSATION = gql`
  query TomConversation($id: String!) {
    tomConversation(id: $id) {
      conversation {
        id
        title
        status
        moduleContext
        entityContext
        lastMessageAt
        messageCount
      }
      messages {
        id
        conversationId
        role
        content
        imageUrls
        toolCalls {
          toolCallId
          toolName
          toolInput
          toolResult
          status
        }
        pendingActions {
          id
          actionType
          summary
          preview
          status
          resultId
          resultSummary
          error
          executedAt
        }
        createdAt
      }
    }
  }
`;

// ============================================================
// Messaging
// ============================================================

export const CREATE_TOM_CONVERSATION = gql`
  mutation CreateTomConversation($input: CreateTomConversationInput!) {
    createTomConversation(input: $input) {
      id
      title
      status
      moduleContext
      entityContext
    }
  }
`;

export const SEND_TOM_MESSAGE = gql`
  mutation SendTomMessage($input: SendTomMessageInput!) {
    sendTomMessage(input: $input) {
      message {
        id
        conversationId
        role
        content
        imageUrls
        toolCalls {
          toolCallId
          toolName
          toolInput
          toolResult
          status
        }
        pendingActions {
          id
          actionType
          summary
          preview
          status
          resultId
          resultSummary
          error
          executedAt
        }
        createdAt
      }
    }
  }
`;

// ============================================================
// Actions
// ============================================================

export const CONFIRM_TOM_ACTION = gql`
  mutation ConfirmTomAction($conversationId: String!, $actionId: String!) {
    confirmTomAction(conversationId: $conversationId, actionId: $actionId) {
      actionId
      status
      resultId
      resultSummary
      error
    }
  }
`;

export const REJECT_TOM_ACTION = gql`
  mutation RejectTomAction($conversationId: String!, $actionId: String!, $reason: String) {
    rejectTomAction(conversationId: $conversationId, actionId: $actionId, reason: $reason)
  }
`;

export const RATE_TOM_MESSAGE = gql`
  mutation RateTomMessage($messageId: String!, $feedback: String!) {
    rateTomMessage(messageId: $messageId, feedback: $feedback)
  }
`;

// ============================================================
// Conversation Management
// ============================================================

export const ARCHIVE_TOM_CONVERSATION = gql`
  mutation ArchiveTomConversation($id: String!) {
    archiveTomConversation(id: $id)
  }
`;

export const DELETE_TOM_CONVERSATION = gql`
  mutation DeleteTomConversation($id: String!) {
    deleteTomConversation(id: $id)
  }
`;

// ============================================================
// Settings
// ============================================================

export const GET_TOM_SETTINGS = gql`
  query TomSettings {
    tomSettings {
      id
      isEnabled
      model
      autoSuggestTasks
      enabledModules
      customSystemPrompt
      maxConversationHistory
    }
  }
`;

export const UPDATE_TOM_SETTINGS = gql`
  mutation UpdateTomSettings($input: UpdateTomSettingsInput!) {
    updateTomSettings(input: $input) {
      id
      isEnabled
      model
      autoSuggestTasks
      enabledModules
      customSystemPrompt
    }
  }
`;

// ============================================================
// IPFS Upload (module-local copies — per module independence rules)
// ============================================================

export const TOM_INITIATE_UPLOAD = gql`
  mutation TomInitiateUpload($fileName: String!, $totalChunks: Float!, $fileSize: Float!) {
    mediaCDNInitiateUpload(fileName: $fileName, totalChunks: $totalChunks, fileSize: $fileSize)
  }
`;

export const TOM_UPLOAD_CHUNK = gql`
  mutation TomUploadChunk($uploadId: String!, $chunkNumber: Float!, $chunk: Upload!) {
    mediaCDNUploadChunk(uploadId: $uploadId, chunkNumber: $chunkNumber, chunk: $chunk)
  }
`;

export const TOM_COMPLETE_UPLOAD = gql`
  mutation TomCompleteUpload($uploadId: String!) {
    mediaCDNCompleteUpload(uploadId: $uploadId) {
      ipfsHash
      url
      fileSize
      mimeType
      fileName
    }
  }
`;

export const TOM_CANCEL_UPLOAD = gql`
  mutation TomCancelUpload($uploadId: String!) {
    mediaCDNCancelUpload(uploadId: $uploadId)
  }
`;

export const TOM_GET_UPLOAD_PROGRESS = gql`
  mutation TomGetUploadProgress($uploadId: String!) {
    mediaCDNGetUploadProgress(uploadId: $uploadId)
  }
`;
